<script lang="ts">
	import Icon from "@components/common/Icon.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { isMenuActive } from "@utils/isMenuActive.js";
	import chevronIcon from "@core/assets/icons/chevron.svg?raw";
	import type { Breadcrumb } from "@core/schema/Breadcrumb.js";
	import BreadcrumbLabel from "./BreadcrumbLabel.svelte";
	import translations from "./Breadcrumbs.translations.json" with { type: "json" };

	const translate = getTranslate(translations);

	const { breadcrumbs, currentPath }: { breadcrumbs: Breadcrumb[]; currentPath?: string } = $props();
	const [secondLastItem] = $derived(breadcrumbs.slice(-2));
</script>

{#if secondLastItem !== undefined}
	<!-- MDN accesible: https://developer.mozilla.org/en-US/docs/Web/CSS/How_to/Layout_cookbook/Breadcrumb_navigation -->
	<nav aria-label={translate("breadcrumbNavAria")} class="mt-6 mb-8 hidden md:block w-full">
		<ol class="flex flex-wrap gap-4 items-center w-full">
			{#each breadcrumbs as breadcrumb, index (breadcrumb)}
				<li class="contents">
					{#if index > 0}
						<Icon icon={chevronIcon} aria-hidden="true" class="text-fcrlightgray -rotate-90 size-6" />
					{/if}
					<BreadcrumbLabel {breadcrumb} active={currentPath !== undefined && isMenuActive(breadcrumb, currentPath)} />
				</li>
			{/each}
		</ol>
	</nav>
	{#if secondLastItem.href}
		<nav class="flex gap-4 md:hidden mt-4 mb-6 items-center flex-wrap">
			<a href={secondLastItem.href}>
				<Icon icon={chevronIcon} aria-label={translate("backAria")} class="text-fcrlightgray rotate-90 size-6" />
			</a>
			<BreadcrumbLabel breadcrumb={secondLastItem} active={false} />
		</nav>
	{/if}
{/if}
